import { Tabs } from 'cpool-components/general/Tabs';
import { useTranslation } from 'react-i18next';

import { REQUEST_HEADER_KINDS, type RequestHeaderKind } from './types';

type Props = {
    contentType: RequestHeaderKind;
    onContentTypeChange: (contentType: RequestHeaderKind) => void;
};

export const CreditRequestHeaderActions: React.FC<Props> = ({ contentType, onContentTypeChange }) => {
    const { t } = useTranslation();
    return (
        <Tabs
            listClassName="w-full"
            selectedId={
                contentType === REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST ? 'NEW_CREDIT_REQUEST' : 'REQUEST_HISTORY'
            }
            onSelect={(id) =>
                onContentTypeChange(
                    id === 'NEW_CREDIT_REQUEST'
                        ? REQUEST_HEADER_KINDS.NEW_CREDIT_REQUEST
                        : REQUEST_HEADER_KINDS.REQUEST_HISTORY,
                )
            }
            tabs={[
                { id: 'NEW_CREDIT_REQUEST', label: t('BANK_CREDIT_REQUEST.NEW_REQUEST') },
                { id: 'REQUEST_HISTORY', label: t('BANK_CREDIT_REQUEST.REQUEST_HISTORY') },
            ]}
        />
    );
};
